// components/ui/Divider.tsx
import { cn } from '../../lib/utils';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  label?: string;
  className?: string;
}

export function Divider({
  orientation = 'horizontal',
  label,
  className
}: DividerProps) {
  if (orientation === 'vertical') {
    return (
      <div className={cn('w-px bg-gray-200 self-stretch', className)} />
    );
  }

  if (label) {
    return (
      <div className={cn('flex items-center gap-4', className)}>
        <div className="flex-1 h-px bg-gray-200" />
        <span className="text-sm text-gray-500 font-medium">{label}</span>
        <div className="flex-1 h-px bg-gray-200" />
      </div>
    );
  }

  return (
    <div className={cn('h-px bg-gray-200 w-full', className)} />
  );
}
